<template>
  <div class="hello">
  </div>
</template>

<script>
export default {
  name: 'cookie-pass',
  data () {
    return {
      formdata: ''
    }
  },
  created() {
    this.formdata = this.$route.params.data
    localStorage.setItem( 'formData', this.formdata );

    const json = JSON.parse(atob(this.formdata));

    if(json.hasOwnProperty('utm_campaign')) {
      self.$cookies.set('utm_campaign', json.utm_campaign, '3y', '', process.env.COOKIE_DOMAIN);
    }

    if(json.hasOwnProperty('utm_campaign_lt')) {
      self.$cookies.set('utm_campaign_lt', json.utm_campaign_lt, '14d', '', process.env.COOKIE_DOMAIN);
    }
  },
  computed: {
    jsondata: function () {
      return atob(this.formdata)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cookie-pass.vue